import {
  Autocomplete,
  Box,
  Button,
  Container,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Select,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles } from "@mui/styles";
import React, { useEffect } from "react";
import CloseIcon from "../../assets/images/plus-circle-fill.svg";


const useStyles = makeStyles({
  boxLeft: {
    width: "25%",
    "padding-bottom": "25px",
  },
  boxRight: {
    width: "75%",
    "padding-bottom": "25px",
  },
});


const DefaultForm = (props) => {
  const { open, close, save } = props
  let { grade, configuration } = props
  const { t, i18n } = useTranslation();
  const [finalGrade, setFinalGrade] = React.useState(grade)


  const handleCloseDialog = () => {
    setFinalGrade(grade)
    close(false);
  };


  const saveGrade = () => {
    if (finalGrade) {
      save(finalGrade);
      //handleCloseDialog(true)
    }
  }


  useEffect(() => {
    setFinalGrade(grade)
  }, [grade])



  return (
    <Dialog onBackdropClick={() => { return false }} open={open} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={false} maxWidth="sm" PaperProps={{ sx: { padding: '30px 30px 15px' } }}>
      <DialogTitle id="form-add-dialog-title" fontSize={24} lineHeight="26.4px" sx={{ padding: "0 0 20px" }}>
        Final Grade
        <Box sx={{ position: "absolute", right: 0, margin: "30px 30px 0  0", top: 0 }}><img onClick={handleCloseDialog} className="clickable" src={CloseIcon} alt="browser" /></Box>
      </DialogTitle>
      <DialogContent sx={{ padding: "0" }}>

        {((configuration?.fill_grade?.grades || []).length > 0) ? (
          <Select
            id="pagination"
            variant="outlined"
            value={finalGrade}
            onChange={e => setFinalGrade(e.target.value)}
            displayEmpty
            fullWidth
            className="white-bg"
            sx={{ marginBottom: '10px' }}
          >
            {configuration?.fill_grade?.grades.map(grade => (
              <MenuItem value={grade}>
                <Typography style={{ fontWeight: "300" }}>{grade}</Typography>
              </MenuItem>
            ))}

          </Select>
        ) : (
          <TextField
            fullWidth
            name="evaluator_comment"
            placeholder={configuration?.fill_grade?.placeholder || ''}
            onChange={e => setFinalGrade(e.target.value)}
            value={finalGrade}
            variant="outlined"
            sx={{ marginBottom: '10px' }}
          />
        )}

        <Box sx={{ justifyContent: "center", display: "flex" }}>
          <Box sx={{ display: "flex", width: "211px", justifyContent: "center" }}>
            <Button color="primary" variant="contained" fullWidth onClick={saveGrade} disabled={!finalGrade} >
              <Typography sx={{ textTransform: "none" }} fontSize={16} lineHeight="29px" fontWeight="500" color="#FFF">Submit</Typography>
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
export default DefaultForm;
